import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../../../@shared/services/user.service";
import {WalletTypeEnum} from "../../../../../@core/enums/wallet-type.enum";
import {AgentKeyEnum} from "../../../../../@core/enums/agent-key.enum";
import {IPaybackWallet} from "../../../../../@core/enums/payback/interfaces/payback-wallet/payback-wallet.interface";
import {IChangePaybackWallet} from "../../../../../@core/enums/payback/interfaces/payback-wallet/change-payback-wallet.interface";

export interface IPaybackWalletDialogData {
  walletType: WalletTypeEnum;
  paybackWallet?: IPaybackWallet;
}

@Component({
  selector: 'app-payback-wallet-dialog',
  templateUrl: './payback-wallet-dialog.component.html',
  styleUrls: ['./payback-wallet-dialog.component.scss']
})
export class PaybackWalletDialogComponent implements OnInit {

  public paybackWalletForm: FormGroup = this.fb.group({
    walletType: [null, [Validators.required]],
    payback: [null, [Validators.required]],
  });

  constructor(private userService: UserService,
              private fb: FormBuilder,
              public dialogRef: MatDialogRef<PaybackWalletDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IPaybackWalletDialogData) {
  }

  ngOnInit(): void {
    if (this.data?.walletType) {
      this.paybackWalletForm.patchValue({walletType: this.data.walletType});
      this.paybackWalletForm.get('walletType')?.disable();
    }
  }

  onSubmit(): void {
    const {walletType, payback} = this.paybackWalletForm.getRawValue();

    const body: IChangePaybackWallet = {
      userId: this.userService.currentUserId.getValue(),
      walletType,
      payback: Number(payback),
      transactionData: {
        agentKey: AgentKeyEnum.ADMIN,
        metaData: {},
      },
    };

    this.userService.changePaybackWallet(body).subscribe((response: IPaybackWallet) => {
      if (response) {
        this.dialogRef.close(response);
      }
    });
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  protected readonly WalletTypeEnum = WalletTypeEnum;
  protected readonly Object = Object;
}
